import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './RentalPortalKeyFactsWidgetItem.module.css'

function RentalPortalKeyFactsWidgetItem({ label, labelEndContent, value }) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [value],
  })

  return (
    <div className={styles.RentalPortalKeyFactsWidgetItem}>
      <div className={styles.labelRow}>
        <Text isSecondary className={styles.label}>
          {label}
        </Text>
        {labelEndContent}
      </div>
      <div className={styles.value}>
        <FloatingTooltip
          content={value}
          disabled={!overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text className={styles.text} ref={setContentOverflowRef}>
            {value}
          </Text>
        </FloatingTooltip>
      </div>
    </div>
  )
}

export default RentalPortalKeyFactsWidgetItem
